import { render, staticRenderFns } from "./WeeklyPlanItem.vue?vue&type=template&id=2d8eaabb&"
import script from "./WeeklyPlanItem.vue?vue&type=script&lang=js&"
export * from "./WeeklyPlanItem.vue?vue&type=script&lang=js&"
import style0 from "./WeeklyPlanItem.vue?vue&type=style&index=0&id=2d8eaabb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports